export default {    
    credentials: localStorage.getItem('sessionState') || null              
}